<template>
  <v-layout
      row
      align-center
  >
    <v-flex
        class="pa-2 ma-1"
    >
      <v-container fluid>
        <v-row>
          <v-col
              cols="12"
              md="12"
              lg="3"
              sm="12"
          >
            <v-card
                class="card-outter"
                height="250px"
                color="#4C787E"
                dark
                @click="setCounterDialog = true"
            >
              <v-card-text>Counter:</v-card-text>
              <v-card-title
                  class="justify-center"
                  style="font-weight: bold;font-size: 50px;height: 100px; word-break: break-word;line-height: normal"
              >
                {{ counter ? counter : "No Counter" }}
              </v-card-title>
              <v-card-actions class="card-actions">
                <v-btn
                    text
                    @click="setCounterDialog = true"
                >Change
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
              cols="12"
              md="12"
              lg="6"
              sm="12"
          >
            <v-card
                class="card-outter"
                :height="$vuetify.breakpoint.xs ? '320px' : '250px'"
            >
              <v-card-title
                  class="justify-center pb-0"
              >
                {{ queue.name }} {{ date }}
              </v-card-title>
              <v-row justify="center">
                <v-col></v-col>
                <v-col cols="6">
                  <v-select
                      :items="times"
                      label="TimeSlot"
                      v-model="selectedTime"
                      outlined
                      @change="getList()"
                  >
                  </v-select>
                </v-col>
                <v-col></v-col>
              </v-row>
              <v-row justify="center">
                <v-switch v-model="not_arrived_card" class="mx-2" label="Appointment"></v-switch>
                <v-switch v-model="arrived_card" class="mx-2" label="Arrived"></v-switch>
                <v-switch v-model="serving_card" class="mx-2" label="Serving"></v-switch>
                <v-switch v-model="served_card" class="mx-2" label="Served"></v-switch>
                <v-switch v-model="cancel_card" class="mx-2" label="Cancel"></v-switch>
              </v-row>
            </v-card>
          </v-col>
          <v-col
              cols="12"
              md="12"
              lg="3"
              sm="12"
          >
            <v-card
                class="card-outter"
                height="250px"
                color="#C74C44"
                dark
                @click="missed()"
            >
              <v-card-title class="headline">Current Calling</v-card-title>
              <v-card-title
                  class="justify-center"
                  style="font-weight: bold; font-size: 50px;height: 125px;"
              >
                {{ currentCallingNo }}
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              v-if="not_arrived_card"
              cols="12"
              lg="6"
              md="12"
              sm="12"
          >
            <v-card
                class="overflow-y-auto"
                max-height="400"
            >
              <v-banner
                  class="justify-center font-weight-bold"
                  sticky
              >
                <v-card-title>
                  Appointment (Not Arrived Yet)
                </v-card-title>
                <v-card-subtitle>Total Pax: {{ yetPax }}</v-card-subtitle>
              </v-banner>
              <v-list-item
                  two-line
                  v-for="qlist2 in yet"
                  :key="qlist2.id"
              >
                <v-list-item-content>
                  <v-row
                      no-gutters
                  >
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>{{ qlist2.name }}</v-list-item-title>
                      <v-list-item-subtitle>Q No : {{ qlist2.queue_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist2.phone_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist2.email }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist2.remarks }}</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-icon x-small>people</v-icon>
                        {{ qlist2.pax }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>{{ itemTitle(qlist2.type) }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                          getTime(qlist2.appointment_date)
                        }}
                      </v-list-item-subtitle>
                      <v-chip
                          class="ma-0"
                          color="secondary"
                          x-small
                          v-if="qlist2.service_id"
                      >
                        {{ getServiceName(qlist2.service_id) }}
                      </v-chip>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>Notify At</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(qlist2.called_at) }}</v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2" style="text-align:right">
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              class="pr-4"
                              v-bind="attrs"
                              v-on="on">phone
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(call, index) in calls"
                              :key="index"
                              @click="calling(qlist2, call.title)"
                          >
                            <v-list-item-title>{{ call.title }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              v-bind="attrs"
                              v-on="on"
                          >fa fa-ellipsis-v
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(action, index) in actions"
                              :key="index"
                              @click="updateStatus(qlist2, action.value)"
                              v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                          >
                            <v-list-item-title
                                v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                              {{ action.title }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col
              v-if="arrived_card"
              cols="12"
              lg="6"
              md="12"
              sm="12"
          >
            <v-card
                class="overflow-y-auto"
                max-height="400"
            >
              <v-banner
                  class="justify-center font-weight-bold"
                  sticky
              >
                <v-card-title>
                  Arrived
                </v-card-title>
                <v-card-subtitle>Total Pax: {{ arrivedPax }}</v-card-subtitle>
              </v-banner>
              <v-list-item
                  v-for="qlist in arrived"
                  :key="qlist.id"
                  two-line
              >
                <v-list-item-content>
                  <v-row
                      no-gutters
                  >
                    <v-col cols="2" sm="2" xs="2">
                      <v-list-item-title>{{ qlist.name }}</v-list-item-title>
                      <v-list-item-subtitle>Q No : {{ qlist.queue_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist.phone_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist.email }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist.remarks }}</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-icon x-small>people</v-icon>
                        {{ qlist.pax }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>{{ itemTitle(qlist.type) }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                          getTime(qlist.appointment_date)
                        }}
                      </v-list-item-subtitle>
                      <v-chip
                          class="ma-0"
                          color="secondary"
                          x-small
                          v-if="qlist.service_id"
                      >
                        {{ getServiceName(qlist.service_id) }}
                      </v-chip>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>Notify At</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(qlist.called_at) }}</v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2">
                      <v-list-item-title>Check in</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(qlist.check_in) }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="qlist.check_out">leave:
                        {{ getTime(qlist.check_out) }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2" style="text-align:right">
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              class="pr-4"
                              v-bind="attrs"
                              v-on="on">phone
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(call, index) in calls"
                              :key="index"
                              @click="calling(qlist, call.title)"
                          >
                            <v-list-item-title>{{ call.title }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs"
                                  v-on="on">fa fa-ellipsis-v
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(action, index) in actions"
                              :key="index"
                              @click="updateStatus(qlist, action.value)"
                              v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                          >
                            <v-list-item-title
                                v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                              {{ action.title }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col
              v-if="serving_card"
              cols="12"
              lg="6"
              md="12"
              sm="12"
          >
            <v-card
                class="overflow-y-auto"
                max-height="400"
            >
              <v-banner
                  class="justify-center font-weight-bold"
                  sticky
              >
                <v-card-title>
                  Serving
                </v-card-title>
                <v-card-subtitle>Total Pax: {{ servingPax }}</v-card-subtitle>
              </v-banner>
              <v-list-item
                  two-line
                  v-for="qlist4 in serving"
                  :key="qlist4.id"
              >
                <v-list-item-content>
                  <v-row
                      no-gutters
                  >
                    <v-col cols="4" sm="4" xs="4">
                      <v-list-item-title>{{ qlist4.name }}</v-list-item-title>
                      <v-list-item-subtitle>Q No : {{ qlist4.queue_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist4.phone_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist4.email }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist4.remarks }}</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-icon x-small>people</v-icon>
                        {{ qlist4.pax }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>{{ itemTitle(qlist4.type) }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                          getTime(qlist4.appointment_date)
                        }}
                      </v-list-item-subtitle>
                      <v-chip
                          class="ma-0"
                          color="secondary"
                          x-small
                          v-if="qlist4.service_id"
                      >
                        {{ getServiceName(qlist4.service_id) }}
                      </v-chip>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>Notify At</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(qlist4.called_at) }}</v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2" style="text-align:right">
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              class="pr-4"
                              v-bind="attrs"
                              v-on="on">phone
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(call, index) in calls"
                              :key="index"
                              @click="calling(qlist4, call.title)"
                          >
                            <v-list-item-title>{{ call.title }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs"
                                  v-on="on">fa fa-ellipsis-v
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(action, index) in actions"
                              :key="index"
                              @click="updateStatus(qlist4, action.value)"
                              v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                          >
                            <v-list-item-title
                                v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                              {{ action.title }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col
              v-if="served_card"
              cols="12"
              lg="6"
              md="12"
              sm="12"
          >
            <v-card
                class="overflow-y-auto"
                max-height="400"
            >
              <v-banner
                  class="justify-center font-weight-bold"
                  sticky
              >
                <v-card-title>
                  Served
                </v-card-title>
                <v-card-subtitle>Total Pax: {{ leftPax }}</v-card-subtitle>
              </v-banner>
              <v-list-item
                  two-line
                  v-for="qlist3 in left"
                  :key="qlist3.id"
              >
                <v-list-item-content>
                  <v-row
                      no-gutters
                  >
                    <v-col cols="2" sm="2" xs="2">
                      <v-list-item-title>{{ qlist3.name }}</v-list-item-title>
                      <v-list-item-subtitle>Q No : {{ qlist3.queue_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist3.phone_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist3.email }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ qlist3.remarks }}</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-icon x-small>people</v-icon>
                        {{ qlist3.pax }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>{{ itemTitle(qlist3.type) }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                          getTime(qlist3.appointment_date)
                        }}
                      </v-list-item-subtitle>
                      <v-chip
                          class="ma-0"
                          color="secondary"
                          x-small
                          v-if="qlist3.service_id"
                      >
                        {{ getServiceName(qlist3.service_id) }}
                      </v-chip>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>Notify At</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(qlist3.called_at) }}</v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2">
                      <v-list-item-title>Check-in</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(qlist3.check_in) }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="qlist3.checkout">leave:
                        {{ getTime(qlist3.check_out) }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2" style="text-align:right">
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              class="pr-4"
                              v-bind="attrs"
                              v-on="on">phone
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(call, index) in calls"
                              :key="index"
                              @click="calling(qlist3, call.title)"
                          >
                            <v-list-item-title>{{ call.title }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs"
                                  v-on="on">fa fa-ellipsis-v
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(action, index) in actions"
                              :key="index"
                              @click="updateStatus(qlist3, action.value)"
                              v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                          >
                            <v-list-item-title
                                v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                              {{ action.title }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col
              v-if="cancel_card"
              cols="12"
              lg="6"
              md="12"
              sm="12"
          >
            <v-card
                class="overflow-y-auto"
                max-height="400"
            >
              <v-banner
                  class="justify-center font-weight-bold"
                  sticky
              >
                <v-card-title>
                  Cancel
                </v-card-title>
                <v-card-subtitle>Total Pax: {{ leftPax }}</v-card-subtitle>
              </v-banner>
              <v-list-item
                  two-line
                  v-for="c in cancel"
                  :key="c.id"
              >
                <v-list-item-content>
                  <v-row
                      no-gutters
                  >
                    <v-col cols="2" sm="2" xs="2">
                      <v-list-item-title>{{ c.name }}</v-list-item-title>
                      <v-list-item-subtitle>Q No : {{ c.queue_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ c.phone_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ c.email }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ c.remarks }}</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-icon x-small>people</v-icon>
                        {{ c.pax }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>{{ itemTitle(c.type) }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                          getTime(c.appointment_date)
                        }}
                      </v-list-item-subtitle>
                      <v-chip
                          class="ma-0"
                          color="secondary"
                          x-small
                          v-if="c.service_id"
                      >
                        {{ getServiceName(c.service_id) }}
                      </v-chip>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>Notify At</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(c.called_at) }}</v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2">
                      <v-list-item-title>Check-in</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(c.check_in) }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="c.checkout">leave: {{
                          getTime(c.check_out)
                        }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2" style="text-align:right">
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              class="pr-4"
                              v-bind="attrs"
                              v-on="on">phone
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(call, index) in calls"
                              :key="index"
                              @click="calling(c, call.title)"
                          >
                            <v-list-item-title>{{ call.title }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs"
                                  v-on="on">fa fa-ellipsis-v
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(action, index) in actions"
                              :key="index"
                              @click="updateStatus(c, action.value)"
                              v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                          >
                            <v-list-item-title
                                v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                              {{ action.title }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col
              v-if="outlet.display_missed"
              cols="12"
              lg="6"
              md="12"
              sm="12"
          >
            <v-card
                class="overflow-y-auto"
                max-height="400"
            >
              <v-banner
                  class="justify-center font-weight-bold"
                  sticky
              >
                <v-card-title>
                  Missed List
                </v-card-title>
                <v-card-subtitle>Total Pax: {{ missedPax }}</v-card-subtitle>
              </v-banner>
              <v-list-item
                  two-line
                  v-for="mQ in missedQ"
                  :key="mQ.id"
              >
                <v-list-item-content>
                  <v-row
                      no-gutters
                  >
                    <v-col cols="2" sm="2" xs="2">
                      <v-list-item-title>{{ mQ.name }}</v-list-item-title>
                      <v-list-item-subtitle>Q No : {{ mQ.queue_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ mQ.phone_no }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ mQ.email }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ mQ.remarks }}</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-icon x-small>people</v-icon>
                        {{ mQ.pax }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>{{ itemTitle(mQ.type) }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                          getTime(mQ.appointment_date)
                        }}
                      </v-list-item-subtitle>
                      <v-chip
                          class="ma-0"
                          color="secondary"
                          x-small
                          v-if="mQ.service_id"
                      >
                        {{ getServiceName(mQ.service_id) }}
                      </v-chip>
                    </v-col>
                    <v-col cols="3" sm="3" xs="3">
                      <v-list-item-title>Notify At</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(c.called_at) }}</v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2">
                      <v-list-item-title>Check-in</v-list-item-title>
                      <v-list-item-subtitle>{{ getTime(mQ.check_in) }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="mQ.checkout">leave: {{
                          getTime(mQ.check_out)
                        }}
                      </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="2" sm="2" xs="2" style="text-align:right">
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              class="pr-4"
                              v-bind="attrs"
                              v-on="on">phone
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(call, index) in calls"
                              :key="index"
                              @click="calling(mQ, call.title)"
                          >
                            <v-list-item-title>{{ call.title }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-menu :absolute="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs"
                                  v-on="on">fa fa-ellipsis-v
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(action, index) in actions"
                              :key="index"
                              @click="updateStatus(mQ, action.value)"
                              v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')"
                          >
                            <v-list-item-title
                                v-if="action.value !== 'missed' || (outlet.display_missed && action.value === 'missed')">
                              {{ action.title }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-dialog v-model="setCounterDialog">
          <v-card>
            <v-card-title class="justify-center headline">Set Counter?</v-card-title>
            <v-container>
              <v-text-field
                  label="Counter"
                  v-model="counter"
                  placeholder="e.g.: Counter 1 / Room 1"
              ></v-text-field>
              <v-card-actions>
                <v-btn color="success" @click="setCounter('yes')">Save</v-btn>
                <v-btn @click="setCounter('no')">No Counter</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: 'monitor',
  props: ['outlet', 'queue', 'services', 'user'],
  data: () => ({
    not_arrived_card: true,
    arrived_card: true,
    serving_card: true,
    served_card: true,
    cancel_card: false,
    currentCount: 0,
    times: [],
    selectedTime: null,
    arrived: [],
    yet: [],
    left: [],
    serving: [],
    cancel: [],
    missedQ: [],
    arrivedPax: 0,
    yetPax: 0,
    leftPax: 0,
    servingPax: 0,
    cancelPax: 0,
    missedPax: 0,
    actions: [
      {
        title: "Not arrived yet",
        value: 'queue',
      },
      {
        title: 'Arrived',
        value: 'arrived',
      },
      {
        title: 'Serving',
        value: 'serving',
      },
      {
        title: 'Cancel',
        value: 'cancel',
      },
      {
        title: 'Served',
        value: 'served',
      },
      {
        title: 'Missed',
        value: 'missed'
      }
    ],
    calls: [
      {
        title: "WhatsApp",
      },
      {
        title: "SMS",
      },
      {
        title: "TV",
      },
    ],
    setCounterDialog: false,
    counter: '',
    selectedQL: null,
    counterSet: false,
    currentCallingNo: null,
    currentCallingQList: null,
  }),
  computed: {
    myBackground() {
      return '/storage' + this.outlet.bg_image;
    },
    myLogo() {
      return '/storage' + this.outlet.logo;
    },
    sloganStyle() {
      return {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '40px',
        color: this.outlet.slogan_color ? this.outlet.slogan_color : '#000000'
      }
    },
  },
  methods: {
    details(q) {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id
    },
    monitor(q) {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id + '/monitor'
    },
    updateStatus(qlist, status) {
      if (status === 'missed') {
        this.missed(qlist)
      } else {
        axios.post('/api/queueList/updateStatus', {
          qlist_id: qlist.id,
          status: status,
          timeStamp: this.selectedTime,
          user_id: this.user.id
        }).then(response => {
          this.getList()
        });
      }
    },
    getList() {
      axios.post('/api/queueList', {
        qid: this.queue.id,
        timeStamp: this.selectedTime
      }).then(result => {
        this.arrived = result.data.arrived;
        this.arrivedPax = result.data.arrivedPax;
        this.yet = result.data.yet;
        this.yetPax = result.data.yetPax;
        this.left = result.data.left;
        this.leftPax = result.data.leftPax;
        this.serving = result.data.serving;
        this.servingPax = result.data.servingPax;
        this.cancel = result.data.cancel;
        this.servingPax = result.data.cancelPax;
        this.missedQ = result.data.missedQ;
        this.missedPax = result.data.missedPax;
      });
    },
    getTime(t) {
      if (t) return t.split(" ")[1];
    },
    whatsapp(ql) {
      let msg = this.formatMsg(ql);
      // https://web.whatsapp.com/send?phone=6598763203&amp;text=%5BQueue+No.+3%5D+Hi+Adrian+koh%2C+it%27s+your+turn+soon.Please+come+back+in+5mins+time.+If+you+missed+your+q+number+by+3+person%2C+please+get+a+new+queue+number.+Thank+you.&amp;source&amp;data&amp;app_absent

      window.open("https://web.whatsapp.com/send?phone=" + ql.phone_no + "&text=" + encodeURI(msg), "whatsapp");
      // window.open("https://wa.me/" + ql.phone_no + "?text=" + msg, "_blank");
      axios.post('/queue/' + this.queue.id + '/list/' + ql.id + '?action=notify&type=whatsapp')
          .then(response => {
            this.getList();
          });
    },
    sms(ql) {
      let msg = this.formatMsg(ql);
      // send sms
      axios.post('/queue/' + this.queue.id + '/list/' + ql.id + '?action=notify&type=sms', {
        msg: msg,
        to: ql.phone_no
      }).then(response => {
        this.getList();
      });
    },
    formatMsg(ql) {
      let displayQNo = this.queue.display_queue_no;
      let msg = this.queue.message ? this.queue.message : "Hi, it is your turn now";
      if (displayQNo) msg = '[Q No. ' + ql.queue_no + '] ' + msg;
      if (msg.includes('{name}')) {
        let name = ql.name ? ql.name : '';
        msg = msg.replaceAll('{name}', name);
      }
      return msg
    },
    calling(ql, type) {
      switch (type) {
        case "WhatsApp":
          this.whatsapp(ql);
          break;
        case "SMS":
          this.sms(ql);
          break;
        case "TV":
          if (window.sessionStorage.getItem('setCounter') === null) {
              swal({
                  title: 'Please set counter!',
                  icon: "warning"
              })
          } else {
            this.currentCallingQList = ql;
            this.tv(ql);
          }
          break;
      }
    },
    tv(ql, type = 'queue') {
      // to call with api action for Apple TV
      axios.post('/queue/' + this.queue.id + '/list/' + ql.id + '?action=notify&type=tv&counter=' + window.sessionStorage.getItem('counter') + '&settype=' + type).then(response => {
        this.currentCallingNo = ql.queue_no;
        this.getList();
      });
    },
    getServiceName(s) {
      let serviceName = '';
      if (this.services.length > 0) {
        this.services.forEach(function (item, index) {
          if (item.id === s) {
            serviceName = item.name
          }
        })
      }
      return serviceName
    },
    setCounter(val) {
      window.sessionStorage.setItem('setCounter', val);
      this.setCounterDialog = false;
      this.counterSet = true;
      if (val === 'yes') {
        window.sessionStorage.setItem('counter', this.counter)
      } else {
        window.sessionStorage.removeItem('counter');
        this.counter = '';
      }
    },
    itemTitle(type) {
      return type === 'onsite' ? 'Walk-in' : 'Appointment';
    },
    missed(qlist) {
      if (confirm("Put this number in missed list?")) {
        if (this.outlet.display_missed) {
          this.tv(qlist, 'missed');
        }
        axios.post('/api/queueList/updateStatus', {
          qlist_id: qlist.id,
          status: 'missed',
          timeStamp: this.selectedTime,
          user_id: this.user.id
        }).then(response => {
          this.getList()
        });
      }
    }
  },
  created() {
    Echo.channel('queue-monitor')
        .listen('.QueueMonitor', (e) => {
          if (e.outlet_id === this.outlet.id && this.selectedTime) this.getList()
        })
  },
  beforeMount() {
    let newDate = new Date();
    let year = newDate.getFullYear();
    let month = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
    let day = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate();
    let today = year + '-' + month + '-' + day;
    this.minDate = today;
    this.date = today;
    // set time slot
    // set selected time
    axios.get('/api/operation_times/model2?qid=' + this.queue.id + '&date=' + this.date)
        .then(response => {
          if (response.data) {
            let temp = [];
            temp.push({'text': 'All', 'value': 'all'});
            response.data.forEach(function (item, index) {
              temp.push({'text': item.time, 'value': item.timestamp});
            });
            this.times = temp;
            // console.log(temp);
            // this.selectedTime = response.data[1].timeStamp;

            // set current count
            // this.getList();
          }
        });
  },
  mounted() {
    this.counter = window.sessionStorage.getItem('counter');
    this.counterSet = window.sessionStorage.getItem('setCounter') === 'yes';
  }
}
</script>
<style>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}

.card-actions {
  position: absolute;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Queues/Monitor.vue